import React from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { ColdWallets } from './coldWallets'
import { Custody } from './custody'
import { Dashboard } from './dashboard'
import { DepositDetails } from './depositDetails'
import { Deposits } from './deposits'
import { Fees } from './fees'
import { GovBr } from './govBr'
import { HotWallets } from './hotWallets'
import { Kyc } from './kyc'
import { Login } from './login'
import { Logout } from './logout'
import { Orderbooks } from './orderbooks'
import { PrivateRoute } from './privateRoute'
import { Services } from './services'
import { UserDetails } from './userDetails'
import { UserKyc } from './userKyc'
import { Users } from './users'
// import { WithdrawDetailsCrypto } from './withdrawDetailsCrypto'
import { WithdrawDetailsFiat } from './withdrawDetailsFiat'
import { Withdrawals } from './withdraws'

export const Main = () => {
	return (
		<div className='main'>
			<Switch>

				<PrivateRoute path='/dashboard' component={Dashboard} />
				<PrivateRoute path='/kyc' component={Kyc} />
				<PrivateRoute path='/deposits' component={Deposits} />
				<PrivateRoute path='/depositDetails/:depositId' component={DepositDetails} />
				<PrivateRoute path='/withdrawals' component={Withdrawals} />
				<PrivateRoute path='/withdrawDetailsFiat/:withdrawId' component={WithdrawDetailsFiat} />
				{/* <PrivateRoute path='/withdrawDetailsCrypto' component={WithdrawDetailsCrypto} /> */}
				<PrivateRoute path='/orderbooks' component={Orderbooks} />
				<PrivateRoute path='/users' component={Users} />
				<PrivateRoute path='/custody' component={Custody} />
				<PrivateRoute path='/fees' component={Fees} />
				<PrivateRoute path='/hotWallets' component={HotWallets} />
				<PrivateRoute path='/coldWallets' component={ColdWallets} />
				<PrivateRoute path='/userKyc/:userId' component={UserKyc} />
				<PrivateRoute path='/userDetails/:userId' component={UserDetails} />
				<PrivateRoute path='/govBr' component={GovBr} />
				<PrivateRoute path='/services' component={Services} />

				<Route path='/login' component={Login} />
				<Route path='/logout' component={Logout} />
				<Route path='/' exact={true} component={Login} />
				<Redirect from='*' to='/' />
			</Switch>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/main.tsx